var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 93,
    viewBox: "0 0 118 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    opacity: 0.5,
    d: "M50.6107 0L32.4569 65.6471L26.4056 41.0294C34.2906 41.0294 40.7086 43.3088 45.6597 47.8676C50.6107 52.4265 53.0863 58.7176 53.0863 66.7412C53.0863 74.5824 50.519 80.9647 45.3846 85.8882C40.4336 90.6294 34.1989 93 26.6807 93C18.979 93 12.561 90.6294 7.42657 85.8882C2.47552 80.9647 0 74.5824 0 66.7412C0 64.3706 0.183372 62.0912 0.550117 59.9029C0.916861 57.5324 1.65035 54.7971 2.75058 51.6971C3.85082 48.5971 5.40948 44.4941 7.42657 39.3882L23.38 0H50.6107ZM115.524 0L97.3706 65.6471L91.3194 41.0294C99.2043 41.0294 105.622 43.3088 110.573 47.8676C115.524 52.4265 118 58.7176 118 66.7412C118 74.5824 115.433 80.9647 110.298 85.8882C105.347 90.6294 99.1127 93 91.5944 93C83.8928 93 77.4747 90.6294 72.3403 85.8882C67.3893 80.9647 64.9137 74.5824 64.9137 66.7412C64.9137 64.3706 65.0971 62.0912 65.4639 59.9029C65.8306 57.5324 66.5641 54.7971 67.6643 51.6971C68.7646 48.5971 70.3232 44.4941 72.3403 39.3882L88.2937 0H115.524Z",
    fill: "#F15215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoute);
export default __webpack_public_path__ + "static/media/qoute.5409b0ccdb78b3a00d3dc89170ce7af0.svg";
export { ForwardRef as ReactComponent };